@if (!platformIsServer && !imageLoaded) {
  <mat-spinner color="secondary" class="center"></mat-spinner>
}
<div class="close-button">
  <button mat-icon-button mat-dialog-close tabindex="-1">
    <mat-icon svgIcon="x"></mat-icon>
  </button>
</div>

<img [src]="data.largeImage" (load)="imageLoaded = true;" [alt]="data.alt" (click)="close()"/>

<div class="title">
  {{ data.title }}
</div>
